import BigNumber from "bignumber.js";

BigNumber.config({ EXPONENTIAL_AT: 12 });

export default {
  getPrecision(n) {
    return new BigNumber(n).dp();
  },
  addSymbol(n) {
    return n >= 0 ? `+${n}` : n;
  },
  toFixed(n: string | number, p: number) {
    if (n === undefined || n === null) {
      return "";
    }
    return parseFloat("" + n).toFixed(p);
  },
  toPrecision(n: string | number, p: number, rm: any = BigNumber.ROUND_DOWN) {
    const c = new BigNumber(n).dp();
    if (c > p) {
      const v = new BigNumber(n).decimalPlaces(p, rm);
      return v !== null ? v.toString() : "";
    } else {
      return n;
    }
  },
  toPercent(v: string | number, symbol: boolean, percision = 2) {
    v = Number(v);
    if (isNaN(v)) {
      return "- -";
    }
    const s = symbol && v >= 0 ? "+" : "";
    if (percision >= 0) {
      return s + (Number(v) * 100).toFixed(percision) + "%";
    }
    const n = new BigNumber(v);
    return n.multipliedBy(100) + "%";
  },
  format(opts: { n: BigNumber.Value; p?: number }) {
    const value = new BigNumber(opts.n);
    const percision = opts.p || (value.lte(10e-2) ? 8 : 2);
    return new BigNumber(opts.n).decimalPlaces(percision).toFormat();
  }
};
